import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/**
 * Un bloc de fiche : un titre, éventuellement une explication, du contenu.
 *
 * Chaque section du dossier réinventait sa carte — en-tête grise ici, titre à
 * emoji là. Le même bloc partout laisse l'œil se fier à la position.
 */
export default function Fiche({ titre, explication, actions, children,
                               sx = {} }) {
  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 }, ...sx }}>
      {(titre || actions) && (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2,
                   justifyContent: 'space-between',
                   mb: explication ? 0.5 : 2 }}>
          {titre && <Typography variant="h2">{titre}</Typography>}
          {actions}
        </Box>
      )}
      {explication && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {explication}
        </Typography>
      )}
      {children}
    </Paper>
  );
}
